import axios from "axios";

class AuthService {
    static async refreshAccessToken() {
        try {
            const url = `${process.env.REACT_APP_API_HOST}/api/user/refresh-accesstoken`;
            const response = await axios.post(url, {}, { withCredentials: true });
            localStorage.setItem('cu_user', response?.data?.data);
            return response?.data;
        } catch (err) {
            return err;
        }
    }
}

export default AuthService;